export const getResponsiveFs = () => {
  const width = window.innerWidth;
  if (width < 1536) return '11px'; // 150%
  return '11px';
};
